import React from 'react';

import * as OrganizationActions from 'actions/OrganizationActions';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Label from 'ui-library/bs/Label';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as nyc from 'ui-library/NYC';
import {InputChangeEvent} from 'util/Types';

export interface CreateTeamPageProps {
  isLoading: boolean;
  organizationId: string;
}

interface State {
  name: string;
}

class CreateTeamPage extends React.Component<CreateTeamPageProps, State> {
  override state: State = {name: ''};

  _updateTeamInfo = ({name}: {name: string}): void => {
    this.setState({name});
  };

  _handleCreateTeam = (): void => {
    OrganizationActions.createTeam({
      name: this.state.name,
      organizationId: this.props.organizationId,
    });
  };

  override render(): JSX.Element {
    const enableCreateTeam = Boolean(this.state.name);
    return (
      <nyc.Container size="lg">
        <nyc.Row>
          <nyc.Col lg={1} />
          <nyc.Col lg={21}>
            <div className="createTeamPage-title">Set up your team on Benchling</div>
          </nyc.Col>
        </nyc.Row>
        <nyc.Row>
          <nyc.Col lg={1} />
          <nyc.Col lg={9}>
            <FormGroup>
              <Label>Give your team a name</Label>
              <FormInput
                placeholder="e.g. Protein Sciences (required)"
                value={this.state.name}
                onChange={(e: InputChangeEvent) => {
                  this._updateTeamInfo({name: e.target.value});
                }}
                disabled={this.props.isLoading}
              />
            </FormGroup>
          </nyc.Col>
        </nyc.Row>
        <nyc.Row>
          <nyc.Col lg={1} />
          <nyc.Col lg={9}>
            <div className="u-spacing-top">
              <Button
                buttonStyle={ButtonStyle.PRIMARY}
                disabled={this.props.isLoading || !enableCreateTeam}
                onClick={this._handleCreateTeam}
                size={ButtonSize.MEDIUM}
                text={this.props.isLoading ? 'Creating...' : 'Create Team'}
              />
            </div>
          </nyc.Col>
        </nyc.Row>
      </nyc.Container>
    );
  }
}

export default CreateTeamPage;
